import React, { memo, forwardRef } from "react";
const SvgEquilibriumwithoverscript = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect width={8} height={10} x={12} y={4} fill="#DBDBDB" rx={1} />
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M22.707 11.293a1 1 0 00-1.414 1.414L24.586 16H5a1 1 0 100 2h22a1 1 0 00.707-1.707l-5-5zM9.293 26.707a1 1 0 001.414-1.414L7.414 22H27a1 1 0 100-2H5a1 1 0 00-.707 1.707l5 5z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgEquilibriumwithoverscript.displayName = "SvgEquilibriumwithoverscript";
const MemoForwardRef = memo(SvgEquilibriumwithoverscript);
export default MemoForwardRef;
